<template>
  <div class="card">
    <div v-if="title && icon" class="card-header">
      <div class="card-header-icon color-secondary">
        <pb-icon :icon="icon" />
      </div>
      <div class="card-header-title">
        <h4 v-html="title" />
      </div>
    </div>
    <div v-if="title && !icon">
      <h4 v-html="title" />
    </div>
    <div v-if="help">
      <span
        title="Clique aqui para visualizar algumas dicas."
        class="card-header pull-right help"
      >
        <pb-icon class="fas fa-question-circle" @click="helper()" />
      </span>
    </div>
    <div
      :class="{
        'card-content': !defaultPadding,
        'card-content-noPadding': defaultPadding,
      }"
    >
      <div v-if="whatsapp" class="whatsapp">
        <PbButton
          color="primary"
          button-style="regular"
          icon="fab fa-whatsapp"
          class="whatsapp-button"
          @click.native="goToWhatsapp"
        >
          <span>VOLTAR PARA WHATSAPP</span>
        </PbButton>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import { PbButton } from 'vue-polar-bear';

export default {
  name: 'Card',

  components: {
    PbButton,
  },

  props: {
    title: { type: String },
    icon: { type: String },
    defaultPadding: { type: Boolean },
    help: { type: String },
    helpActivity: { type: String },
    whatsapp: { type: String, default: '' },
  },

  data() {
    return {
    };
  },
  methods: {
    helper() {
      if (this.helpActivity) brain.setActivity(this.helpActivity);
      if (this.help) {
        brain.swal({
          html: this.help,
          confirmButtonText: 'Ok, entendi!',
          width: 530,
        });
      }
    },

    goToWhatsapp() {
      window.location.href = `https://api.whatsapp.com/send?phone=${this.whatsapp}`;
    },
  },
};
</script>

<style scoped lang="scss">
.help {
  cursor: pointer;
}

.card {
  background: #fff;
  margin-top: 40px;
  padding: 5px 15px 20px 15px;
  border-radius: 6px;
  box-shadow: 0 1px 15px -12px rgba(0, 0, 0, 0.42),
    0 4px 4px 0px rgba(0, 0, 0, 0.12), 0 4px 4px -5px rgba(0, 0, 0, 0.2);
  @media screen and (max-width: 420px) {
    padding: 5px 15px 20px 15px;
  }
}

.card-header {
  display: flex;
  align-items: flex-end;
  margin-top: -25px;
}

.card-header-icon {
  color: white;
  font-size: 1.6em !important;
  border-radius: 6px;
  padding: 15px;
  margin-right: 10px;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42),
    0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

.card-header-icon {
  i {
    padding: 5px;
  }
}

.card-header-title h4 {
  text-transform: uppercase;
  margin-bottom: 5px;
}

.card-content {
  margin: 10px 50px 10px 50px;
  @media screen and (max-width: 420px) {
    margin: 10px 0px 10px 0px;
  }
}

.card-content-noPadding {
  margin: 10px 10px 10px 10px;
  @media screen and (max-width: 420px) {
    margin: 10px 0px 10px 0px;
  }
}

.whatsapp {
  margin: 15px 0px;
  text-align: right;

  /** this is a workaround because the default button style is with 14px (app.scss) D: */
  .whatsapp-button::v-deep .pb-button-container svg {
    font-size: 20px !important;
  }
}
</style>
